import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

export default function Footer() {
  const Line = styled.div`
    border-top: 2.5px solid #6debb5;
  `;

  return (
    <>
      <Line />
      <Container className="py-5">
        <Row>
          <Col lg={6} md={6} sm={12} xs={12}>
            <h1 className="font-primary color-primary text-lg-start text-md-start text-center">
              C T S
            </h1>
            <p className="font-secondary color-secondary text-lg-start text-md-start text-center">
              Todos os direitos reservados ©Code Tech Store (CTS).
            </p>
          </Col>
          <Col
            lg={3}
            md={3}
            sm={6}
            xs={6}
            className="font-secondary color-secondary"
          ></Col>
          <Col
            lg={3}
            md={3}
            sm={6}
            xs={6}
            className="font-secondary color-secondary"
          >
          </Col>
        </Row>
      </Container>
    </>
  );
}
